import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverList } from "@/api/gmToolNew/gmToolNew";
import addserver from "./components/addserver.vue";
import modifyBatchServer from "./components/modifyBatchServer.vue";
import mergeServers from "./components/mergeServers.vue";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "serverManagement",
  components: {
    addserver: addserver,
    modifyBatchServer: modifyBatchServer,
    mergeServers: mergeServers
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      isPrize: false,
      prizeList: [],
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      paramsData: {
        page: 1
      },
      isCode: false,
      codeLists: [],
      SelectionList: [],
      isMobile: false
    };
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.paramsData.page = val;
      this.getList();
    },
    getList: function getList() {
      this.serverChannelChange();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.SelectionList = e;
    },
    modifyData: function modifyData() {
      var idList = [];
      this.serverListYJ.forEach(function (item) {
        idList.push({
          "server_name": item.serverName,
          "server_id": item.serverID
        });
      });
      this.$refs.modifyBatchServer.open(JSON.stringify(idList));
    },
    mergeServers: function mergeServers() {
      var idList = [];
      this.serverListYJ.forEach(function (item) {
        idList.push({
          "server_name": item.serverName,
          "server_id": item.serverID,
          "serverPort": item.serverPort,
          "serverIP": item.serverIP
        });
      });
      this.$refs.mergeServers.open(JSON.stringify(idList));
    }
  }
};